const signUpSchema = {
  name: {
    presence: { allowEmpty: false, message: "obrigatório" },
  },
  email: {
    presence: { allowEmpty: false, message: "obrigatório" },
    email: {
      message: "Este e-mail não é válido"
    }
  },
  cpf: {
    presence: { allowEmpty: false, message: "obrigatório" },
    length: {
      is: 14,
    },
    format: {
      pattern: "^[0-9]{3}.?[0-9]{3}.?[0-9]{3}-?[0-9]{2}",
      message: "O CPF deve conter 11 dígitos",
    }
  },
  password: {
    presence: { allowEmpty: false, message: "obrigatório" },
    length: {
      maximum: 25,
      minimum: 5,
      tooShort: "A senha precisa ter no mínimo 5 caracteres",
      tooLong: "A senha pode ter no máximo 25 caracteres",
    },
  },
  confirmPassword: {
    presence: { allowEmpty: false, message: "obrigatório" },
    equality: {
      attribute: "password",
      message: "As senhas não coincidem"
    },
  },
};

export default signUpSchema;